// extracted by mini-css-extract-plugin
export default {"root":"_23VhR","icon":"_22SA3","tooltip":"_2L33x"};